
import { Component, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
@Component({
  selector: 'empty-tenants',
  standalone: true,
  imports: [TranslateModule, ButtonModule],
  templateUrl: './empty-tenants.component.html',
})
export class EmptyTenantsComponent {
  readonly onAction = output<{ action: string }>();

  constructor() { }

  GoToCreateTenant(){
    this.onAction.emit({action:"CreateTenant"});
  }

}
